import React from 'react';
import { Link } from "react-router-dom";
import { Form } from 'antd';
import { NumericFormat } from 'react-number-format';
import NoData from 'src/components/shared/noDataComponent';
const Info = ({ caseDetails }) => {
  return (
    <div className={"border border-StrokeColor rounded-5 p-4 mt-7"}  >
      {!caseDetails?.commonModel && <div className="chart-nodata justify-center"><span><NoData /></span></div>}
                <div className='grid grid-cols-1 xl:grid-cols-3 md:grid-cols-2 gap-4'>
      {caseDetails?.commonModel && (
        Object.entries(caseDetails?.commonModel).map(([key, value], idx) => {
          const renderValue = () => {
            if (value === null || value === " " || value === "") {
              return "";
            } else if (
              isNaN(value) ||
              key === 'Transaction Id' ||
              key === 'Bank Account number/IBAN' ||
              key === "Bank Account Number/IBAN" ||
              key === 'Bank Name' ||
              key === "Wallet Address"
            ) {
              if (key === 'Name') {
                return <Link>{value}</Link>;
              } else {
                return value;
              }
            } else {
              return <NumericFormat value={value} decimalSeparator="." displayType={'text'} thousandSeparator={true} />;
            }
          };
     
          return (
            <Form.Item name='commonModel'className=''key={key}>             
                <div className="flex items-center gap-1.5 ksbk">
                  <div>
                     <span className={`icon ${key.toLowerCase()}-icon`}></span>
                  </div>
                  <div className="">
                    <p className='summary-label'>{key}</p>
                    <div className='summary-value !break-words xl:!w-[140px] lg:!w-[120px]'>
                      {renderValue()}
                    </div>
                  </div>
                </div>
            </Form.Item>
          );
        })
      )}
    </div>
    </div>
  );
};
export default Info;
